import React, { useState } from 'react';

const TestimonialsSection = () => {
  const students = [
    {
      name: 'Phạm Minh Quân',
      achievement: 'HSG Toán cấp quận giải nhì 10 điểm',
      avatar: 'PMQ',
      content: '"Con vốn là một đứa trẻ sống kha khép kín những khi học với cô Nam Kiến Văn, chị thầy cô chia sẻ những hơn và rất hào hứng trong mỗi giờ học. Đặc biệt thầy Sỹ Đạt đã truyền cho con cảm hứng rất lớn để vui môn toán và để lại ấn tượng trong con."',
      subtitle: 'Sẻ sự quan tâm 11 tuổi thôi'
    },
    {
      name: 'Nghiêm Hải Anh',
      achievement: 'Toán học kỳ II 9 điểm',
      avatar: 'NHA',
      content: '"Học với thầy cô rất vui và bổ ích, em đã tiến bộ rõ rệt trong học tập."',
      subtitle: 'Học sinh lớp 9'
    },
    {
      name: 'Nguyễn Minh Thiên',
      achievement: 'Tổ hợp khối D07 26 điểm',
      avatar: 'NMT',
      content: '"Các thầy cô rất tận tâm và giúp em phát triển kỹ năng học tập."',
      subtitle: 'Học sinh lớp 12'
    },
    {
      name: 'Nguyễn Thị Huyền Như',
      achievement: 'Tổ hợp khối D01 26.5 điểm',
      avatar: 'NTHN',
      content: '"Môi trường học tập thân thiện và đầy cảm hứng."',
      subtitle: 'Học sinh lớp 11'
    },
    {
      name: 'Hoàng Ngọc Mai',
      achievement: 'Tổ hợp khối C01 25 điểm',
      avatar: 'HNM',
      content: '"Thầy cô giúp em tự tin hơn trong các kỳ thi."',
      subtitle: 'Học sinh lớp 10'
    },
    {
      name: 'Đặng Thị Quỳnh',
      achievement: 'Tổ hợp khối A00 28.35 điểm',
      avatar: 'DTQ',
      content: '"Cảm ơn thầy cô đã giúp em đạt được kết quả tốt."',
      subtitle: 'Học sinh lớp 12'
    }
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handlePrev = () => {
    setSelectedIndex((prevIndex) => (prevIndex === 0 ? students.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex === students.length - 1 ? 0 : prevIndex + 1));
  };

  const handleSelect = (index) => {
    setSelectedIndex(index);
  };

  const testimonial = students[selectedIndex];

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">
          Phụ huynh - Học sinh tại <span className="text-green-600">Nam Kiến Văn chia sẻ gì?</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Student List */}
          <div className="space-y-4">
            {students.map((student, index) => (
              <div 
                key={index} 
                onClick={() => handleSelect(index)}
                className={`flex items-center p-4 rounded-lg transition-colors cursor-pointer ${
                  index === selectedIndex ? 'bg-blue-50 border-l-4 border-blue-500' : 'bg-white hover:bg-gray-50'
                }`}
              >
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold mr-4">
                  {student.avatar.charAt(0)}
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">{student.name}</h3>
                  <p className="text-sm text-gray-600">{student.achievement}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side - Testimonial */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex items-start mb-6">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold mr-4 flex-shrink-0">
                {testimonial.avatar}
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">{testimonial.name}</h3>
                <p className="text-sm text-gray-600">{testimonial.achievement}</p>
              </div>
            </div>

            <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4">
              <p className="text-gray-700 italic leading-relaxed">
                {testimonial.content}
              </p>
            </div>

            <div className="flex items-center justify-between">
              <p className="text-sm text-gray-500">{testimonial.subtitle}</p>
              <div className="flex space-x-2">
                <button 
                  onClick={handlePrev}
                  className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
                  aria-label="Previous testimonial"
                >
                  ←
                </button>
                <button 
                  onClick={handleNext}
                  className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
                  aria-label="Next testimonial"
                >
                  →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
